import CheckIcon from '@mui/icons-material/Check';
import React from 'react';

export const ThumbnailSatellite1 = () => (
  <svg width="52" height="36" viewBox="0 0 52 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="52" height="36" rx="4" fill="#2d4a2d" />
    <rect x="0" y="0" width="52" height="36" rx="4" fill="url(#sat1grad)" />
    <rect x="6" y="8" width="10" height="8" rx="1" fill="#1a3a1a" opacity="0.8" />
    <rect x="20" y="6" width="14" height="10" rx="1" fill="#1a3a1a" opacity="0.8" />
    <rect x="8" y="20" width="8" height="8" rx="1" fill="#1a3a1a" opacity="0.7" />
    <rect x="28" y="19" width="12" height="9" rx="1" fill="#1a3a1a" opacity="0.7" />
    <rect x="38" y="8" width="8" height="6" rx="1" fill="#1a3a1a" opacity="0.6" />
    <defs>
      <linearGradient id="sat1grad" x1="0" y1="0" x2="52" y2="36" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#4a7a4a" stopOpacity="0.6" />
        <stop offset="100%" stopColor="#2d5a2d" stopOpacity="0.4" />
      </linearGradient>
    </defs>
  </svg>
);

export const ThumbnailSatellite2 = () => (
  <svg width="52" height="36" viewBox="0 0 52 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="52" height="36" rx="4" fill="#3a4a2a" />
    <rect x="0" y="0" width="52" height="36" rx="4" fill="url(#sat2grad)" />
    <rect x="4" y="6" width="12" height="9" rx="1" fill="#253520" opacity="0.9" />
    <rect x="20" y="5" width="16" height="11" rx="1" fill="#253520" opacity="0.9" />
    <rect x="6" y="19" width="9" height="9" rx="1" fill="#253520" opacity="0.8" />
    <rect x="30" y="18" width="14" height="10" rx="1" fill="#253520" opacity="0.8" />
    <rect x="40" y="6" width="7" height="7" rx="1" fill="#253520" opacity="0.7" />
    <defs>
      <linearGradient id="sat2grad" x1="0" y1="36" x2="52" y2="0" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#6a9a5a" stopOpacity="0.5" />
        <stop offset="100%" stopColor="#3a6a3a" stopOpacity="0.3" />
      </linearGradient>
    </defs>
  </svg>
);

export const ThumbnailStreet = () => (
  <svg width="52" height="36" viewBox="0 0 52 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="52" height="36" rx="4" fill="#f0ebe3" />
    <rect x="0" y="15" width="52" height="6" fill="#ffffff" />
    <rect x="21" y="0" width="10" height="36" fill="#ffffff" />
    <rect x="2" y="2" width="17" height="11" rx="1" fill="#e8e0d4" />
    <rect x="33" y="2" width="17" height="11" rx="1" fill="#e8e0d4" />
    <rect x="2" y="23" width="17" height="11" rx="1" fill="#e8e0d4" />
    <rect x="33" y="23" width="17" height="11" rx="1" fill="#e8e0d4" />
    <line x1="26" y1="0" x2="26" y2="15" stroke="#d4c9b8" strokeWidth="0.5" strokeDasharray="2,2" />
    <line x1="26" y1="21" x2="26" y2="36" stroke="#d4c9b8" strokeWidth="0.5" strokeDasharray="2,2" />
  </svg>
);

export const ThumbnailStreetDark = () => (
  <svg width="52" height="36" viewBox="0 0 52 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="52" height="36" rx="4" fill="#101216" />
    <rect x="0" y="15" width="52" height="6" fill="#272b33" />
    <rect x="21" y="0" width="10" height="36" fill="#272b33" />
    <rect x="2" y="2" width="17" height="11" rx="1" fill="#1a1e25" />
    <rect x="33" y="2" width="17" height="11" rx="1" fill="#1a1e25" />
    <rect x="2" y="23" width="17" height="11" rx="1" fill="#1a1e25" />
    <rect x="33" y="23" width="17" height="11" rx="1" fill="#1a1e25" />
    <line x1="26" y1="0" x2="26" y2="15" stroke="#3b4352" strokeWidth="0.5" strokeDasharray="2,2" />
    <line x1="26" y1="21" x2="26" y2="36" stroke="#3b4352" strokeWidth="0.5" strokeDasharray="2,2" />
  </svg>
);

export const MAP_LAYER_OPTIONS = [
  {
    id: 'satellite1',
    label: 'Satelital 1',
    sublabel: 'Vista aérea',
    Thumbnail: ThumbnailSatellite1,
  },
  {
    id: 'satellite2',
    label: 'Satelital 2',
    sublabel: 'Vista aérea alternativa',
    Thumbnail: ThumbnailSatellite2,
  },
  {
    id: 'street',
    label: 'Calle',
    sublabel: 'Mapa cartográfico',
    Thumbnail: ThumbnailStreet,
    requiresIgn: true,
  },
  {
    id: 'streetDark',
    label: 'Calle oscuro',
    sublabel: 'Mapa cartográfico oscuro',
    Thumbnail: ThumbnailStreetDark,
    requiresIgn: true,
  },
];

/** Leyenda panel — alineada con `pc_bucket` en tiles (Censo 2010). */
export const POBREZA_CRONICA_ARGENTINA_LEGEND = [
  { value: 'muy_bajo', shortLabel: 'Muy bajo', pctMin: 0, pctMax: 0.99, label: 'Muy bajo (0–0,99%)', color: '#1A9850' },
  { value: 'bajo', shortLabel: 'Bajo', pctMin: 1, pctMax: 4.99, label: 'Bajo (1–4,99%)', color: '#91CF60' },
  { value: 'moderado', shortLabel: 'Moderado', pctMin: 5, pctMax: 9.99, label: 'Moderado (5–9,99%)', color: '#D9EF8B' },
  { value: 'alto', shortLabel: 'Alto', pctMin: 10, pctMax: 14.99, label: 'Alto (10–14,99%)', color: '#FEE08B' },
  { value: 'muy_alto', shortLabel: 'Muy alto', pctMin: 15, pctMax: 24.99, label: 'Muy alto (15–24,99%)', color: '#FC8D59' },
  { value: 'critico', shortLabel: 'Crítico', pctMin: 25, pctMax: 100, label: 'Crítico (25–100%)', color: '#D73027' },
  { value: 'sin_dato', shortLabel: 'Sin dato', label: 'Sin dato', color: '#BDBDBD' },
];

export const POBREZA_CRONICA_ARGENTINA_BUCKETS = POBREZA_CRONICA_ARGENTINA_LEGEND.filter(
  (item) => item.value !== 'sin_dato' && item.pctMin != null,
);

/** Leyenda del mapa (`incidencia` 1|2|3) y bandas de `flood_risk_pct` en detalle del lote. */
export const ZONAS_INUNDABLES_LEGEND = [
  { value: 1, label: 'Leve', pctMin: 70, pctMax: 79, color: '#4daf4a' },
  { value: 2, label: 'Moderada', pctMin: 80, pctMax: 97, color: '#ffd92f' },
  { value: 3, label: 'Crítica', pctMin: 100, pctMax: 100, color: '#e41a1c' },
];

export const formatZonasInundablesLegendLabel = (item) => {
  const { label, pctMin, pctMax } = item;
  if (pctMin == null || pctMax == null) return label;
  if (pctMin === pctMax) return `${label} (${pctMin}%)`;
  return `${label} (${pctMin}–${pctMax}%)`;
};

export const ActiveOptionCheck = () => (
  <CheckIcon
    style={{
      fontSize: '16px',
      color: 'rgba(255,255,255,0.7)',
      flexShrink: 0,
    }}
  />
);

